/* eslint-disable jsx-a11y/anchor-is-valid */
import React, { useState } from "react";
import SystemConfigurations from "./SystemConfigurations"
import UserMaintenance from "../maintenance/user-maintenance/UserMaintenance"
import ReportSettingsTable from "../settings/reports/ReportSettingsTable"

export default function Settings() {
  const [activeSetting, setActiveSetting] = useState("System Configuration");

  const handleSettingClick = (setting) => {
    setActiveSetting(setting);
  };

  return (
    <div className="vlp-component-container">
      <span className="title">Settings</span>
      <hr />
      <div className="columns">
        {/* <div className="column is-2 vlp-custom-side-nav">
          <aside className="menu">
            <ul className="menu-list">
              {['System Configuration', 'Users', 'Reports'].map((setting) => (
                <li key={setting}>
                  <a
                    className={activeSetting === setting ? "is-active" : ""}
                    onClick={() => handleSettingClick(setting)}
                  >
                    {setting}
                  </a>
                </li>
              ))}
            </ul>
          </aside>
        </div> */}
        <div className="column">
          {activeSetting === "System Configuration" && <SystemConfigurations />}

          {activeSetting === "Users" && <UserMaintenance />}

          {activeSetting === 'Reports' && (
            <ReportSettingsTable/>              
          )}

          {activeSetting === "Setting-4" && (
            <div>
              <h1>Setting 4 Content</h1>
              <p>This is the content for Setting 4.</p>
            </div>
          )}

          {activeSetting === "Setting-5" && (
            <div>
              <h1>Setting 5 Content</h1>
              <p>This is the content for Setting 5.</p>
            </div>
          )}
        </div>
      </div>
    </div>
  );
}
